/* eslint-disable no-use-before-define */
import React from 'react'
import {
    CartesianGrid,
    ResponsiveContainer,
    Scatter,
    ScatterChart,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts'
import useScatterGraph from './use-scatter-graph'
import {
    BenchmarkTooltipContent,
    BenchmarkTooltipCursor,
    BenchmarkShape,
} from './benchmark'
import chartOfferingTooltip from './tooltip'

export default () => {
    const ctx = useScatterGraph()
    const {
        colors,
        benchmarks, selectedBenchmarks, benchmarksData,
        RATING_VALUES, ratings, offersData,
    } = ctx

    return (<React.Fragment>
        <ResponsiveContainer width="100%" height={350}>
        <ScatterChart
            margin={{
                top: 5, right: 40, left: 0, bottom: 5,
            }}
        >
        <CartesianGrid vertical={false} />

        <XAxis dataKey="x"
            type="number"
            domain={[0,30]}
            scale="linear"
            unit=" yr"
            ticks={[0,5,10,15,20,25,30]}
            />

        <YAxis dataKey="y"
            domain={[0, dataMax => (Math.floor(dataMax) + 2)]}
            width={5}
            unit='.0%'
            scale='linear'
            axisLine={false}
            orientation='right' />

        {
            benchmarks
            .map((a,i) => {
                return {
                    label: a,
                    data: benchmarksData[a] || [],
                    color: colors[i],
                    selected: selectedBenchmarks.indexOf(a)>=0
                }
            })
            .filter(a => a.selected)
            .map( (a,i) =>
                <Scatter key={i}
                data={a.data}
                dot={true}
                shape={<BenchmarkShape r={2} fill={a.color} />}
                line={{stroke:a.color, strokeWidth:2}}
                />
            )
        }

        {
            RATING_VALUES
            .map((a,i) => {
                return {
                    label: a,
                    data: offersData[a] || [],
                    color: colors[5+i],
                    selected: ratings.indexOf(a)>=0
                }
            })
            .filter(a => a.selected)
            .map( (a,i) =>
                <Scatter key={5+i}
                data={a.data}
                fill={a.color}
                {...chartOfferingTooltip}
                />
            )
        }

        <Tooltip
            position={{y:0}}
            offset={1}
            content={<BenchmarkTooltipContent {...ctx} />}
            isAnimationActive={false}
            cursor={<BenchmarkTooltipCursor />}
            wrapperStyle={{zIndex:3}}
            />

        </ScatterChart>
        </ResponsiveContainer>
    </React.Fragment>)
}